var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 10 160 140",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FC6432",
    cx: 79.9,
    cy: 79.9,
    r: 79.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.5,122L95.3,95H120V84.8H39V95h24.7l-17.2,27h12.8l20.2-31.7L99.7,122H112.5z M120,74.9V64.7H95.8l17-26.7 H99.9L79.5,70.2L59.1,38H46.2l17,26.7H39V75L120,74.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStx);
export default __webpack_public_path__ + "static/media/stx.818fd70db857c4b9b2950bac32af353a.svg";
export { ForwardRef as ReactComponent };